import React from 'react';

export default ({ fillColor }) => (
  <svg width="391.635" height="148.889" viewBox="0 0 391.635 148.889">
    <path
      id="mobile-bottom-background-blob"
      d="M-2573,6058.27s141.984,12.54,264.029-7.543,127.606-27.331,127.606-27.331v148.889H-2573Z"
      transform="translate(2573 -6023.396)"
      fill={`${fillColor ? `${fillColor}40` : '#f5f2fe'}`}
    />
  </svg>
);
